const dateDiff = (day1, day2) => {
    const diff = new Date(day1 - day2);

    const dateDiffMinutes = Math.round(diff.getTime() / 1000 / 60);
    const dateDiffHours = Math.round(diff.getTime() / 1000 / 60 / 60);
    const dateDiffDay = Math.round(diff.getTime() / 1000 / 60 / 60 / 24);

    if (dateDiffHours <= 24 && dateDiffDay < 1) {
        if (dateDiffMinutes < 60 && dateDiffHours < 1) {
            return 'há alguns minutos';
        } else {
            return 'há ' + dateDiffHours + ' horas';
        }
    } else if (dateDiffDay <= 15) {
        return 'há ' + dateDiffDay + ' dias';
    } else {
        return day2.toLocaleDateString('pt-BR').toString();
    }
};

export default {
    dateDiff
};
